var render = function render(){var _vm=this,_c=_vm._self._c;return _c('GmbSticker',{staticClass:"gmb-individual-sticker",attrs:{"text":_vm.safeCountRepr(_vm.individualCount),"isLarge":_vm.isLarge}},[_c('FdText',{attrs:{"fa":"","fontSizeSmaller1":""}},[_c('i',{staticClass:"fas fa-male"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }